export type MenuPageKey =
  | 'breaks'
  | 'home'
  | 'overview'
  | 'clientCallbacks'
  | 'formV2'
  | 'users'
  | 'teams'
  | 'offices'
  | 'websalesUsers'
  | 'ipAddresses'
  | 'providers'
  | 'suppliers'
  | 'providerOptions'
  | 'additionalSales'
  | 'assistanceProducts'
  | 'carbonOffset'
  | 'servicesStatus'
  | 'devTools'

export type MenuFamilyKey = 'usersAndTeams' | 'partners' | 'providers' | 'additionalSales'

export type MenuVertical = 'energie' | 'telecom' | 'assurance'

export interface MenuFamilyConfig {
  family: MenuFamilyKey
  icon: string
  pages: MenuPageKey[]
}

export type MenuAdminItemConfig = MenuPageKey | MenuFamilyConfig

export const AGENT_MENU_PAGES: MenuPageKey[] = ['breaks', 'home', 'overview', 'clientCallbacks', 'formV2']

export const ADMIN_MENU_ITEMS: MenuAdminItemConfig[] = [
  { family: 'usersAndTeams', icon: 'users', pages: ['users', 'teams', 'offices'] },
  { family: 'partners', icon: 'partners', pages: ['websalesUsers', 'ipAddresses'] },
  { family: 'providers', icon: 'providers', pages: ['providers', 'suppliers', 'providerOptions'] },
  {
    family: 'additionalSales',
    icon: 'additionalSales',
    pages: ['additionalSales', 'assistanceProducts', 'carbonOffset', 'servicesStatus'],
  },
  'devTools',
]

// Pages whose label doesn't change keep the key the menu already uses without the redesign.
export const PAGE_LABEL_KEYS: Record<MenuPageKey, string> = {
  breaks: 'menu:breaks',
  home: 'menu:home',
  overview: 'menu:overview',
  clientCallbacks: 'menu:clientCallbacks',
  formV2: 'menu:redesign.formV2',
  users: 'menu:redesign.users',
  teams: 'menu:redesign.teams',
  offices: 'menu:offices',
  websalesUsers: 'menu:websalesUsers',
  ipAddresses: 'menu:redesign.ipAddresses',
  providers: 'menu:redesign.providers',
  suppliers: 'menu:redesign.suppliers',
  providerOptions: 'menu:redesign.providerOptions',
  additionalSales: 'menu:redesign.additionalSales',
  assistanceProducts: 'menu:redesign.assistanceProducts',
  carbonOffset: 'menu:redesign.carbonOffset',
  servicesStatus: 'menu:redesign.servicesStatus',
  devTools: 'menu:devTools',
}

export const FAMILY_LABEL_KEYS: Record<MenuFamilyKey, string> = {
  usersAndTeams: 'menu:redesign.families.usersAndTeams',
  partners: 'menu:redesign.families.partners',
  providers: 'menu:redesign.families.providers',
  additionalSales: 'menu:redesign.families.additionalSales',
}

export const VERTICALS_FAMILY = {
  id: 'verticals',
  icon: 'verticals',
  labelKey: 'menu:redesign.families.verticals',
}

export const VERTICAL_ICON_KEYS: Record<MenuVertical, string> = {
  energie: 'energy-app',
  telecom: 'telecom-app',
  assurance: 'insurance-app',
}

export const VERTICAL_LABEL_KEYS: Record<MenuVertical, string> = {
  energie: 'menu:redesign.verticals.energie',
  telecom: 'menu:redesign.verticals.telecom',
  assurance: 'menu:redesign.verticals.assurance',
}

export const CURRENT_VERTICAL_LABEL_KEY = 'menu:redesign.currentVertical'

export const LOGOUT_LABEL_KEY = 'menu:redesign.logout'
